export var TitleSizes;

(function (TitleSizes) {
  TitleSizes["Small"] = "SMALL";
  TitleSizes["Medium"] = "MEDIUM";
  TitleSizes["Large"] = "LARGE";
})(TitleSizes || (TitleSizes = {}));

export var NavigationAlignments;

(function (NavigationAlignments) {
  NavigationAlignments["Leading"] = "ALIGNMENTS/LEADING";
  NavigationAlignments["Trailing"] = "ALIGNMENTS/TRAILING";
})(NavigationAlignments || (NavigationAlignments = {}));